import { render, staticRenderFns } from "./AppUse.vue?vue&type=template&id=888b597a";
import script from "./AppUse.vue?vue&type=script&lang=js";
export * from "./AppUse.vue?vue&type=script&lang=js";
import style0 from "./AppUse.vue?vue&type=style&index=0&id=888b597a&prod&lang=less";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;